<section class="account-summary mt-5">
  <app-user-profile-card></app-user-profile-card>

  <app-user-proposal></app-user-proposal>
</section>
